module.exports = __webpack_public_path__ + "9cb0ba7c8293fcf62e817e748338e5fb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/5_E2.mp3
// module id = 102
// module chunks = 0